<template>
  <Layout>
      <div v-show="pedidos_cancelamentos > 0" class="col-sm-12">
        <Transition name="slide-down">
          <div class="alert-cancelamento">
            <div class="alert-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <circle cx="10" cy="10" r="9" stroke="#b45309" stroke-width="1.5"/>
                <path d="M10 6v5" stroke="#b45309" stroke-width="1.5" stroke-linecap="round"/>
                <circle cx="10" cy="14" r="0.8" fill="#b45309"/>
              </svg>
            </div>
            <div class="alert-body">
              <p class="alert-title">Atenção — pedidos de cancelamento pendentes</p>
              <p class="alert-desc">
                Há <strong>{{ pedidos_cancelamentos }} {{ pedidos_cancelamentos === 1 ? 'pedido' : 'pedidos' }}</strong>
                de cancelamento aguardando análise e aprovação.
              </p>
            </div>
            <div class="alert-actions">
              <button class="btn-cancelamento" @click="pagePedidos()">
                Ver pedidos
                <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                  <path d="M2.5 6.5h8M7 3l3.5 3.5L7 10" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </Transition>
      </div>
    <NotaFiscalDashboard :is-admin="true"/>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import NotaFiscalDashboard from "@/router/views/dashboards/components/NotaFiscalDashboard.vue";

const {listNotasPedidosCancelamento} = require("../../../api/nfse/nota");
export default {
  page: {
    title: "Painel",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    NotaFiscalDashboard,
    Layout
  },
  data() {
    return {
      title: "Painel",
      items: [
        {
          text: "Painel",
          active: true,
        }
      ],
      httpFichaCadastro: false,
      user: null,
      empresa: null,
      filtros_pedidos_cancelamento: {
        pagina: 1,
        status: '1',
      },
      pedidos_cancelamentos: [],
      duams: [],
      contadores: {
        total_contribuinte: 0,
        total_movimento: 0.00,
        total_nota: 0,
      }
    };
  },
  created() {
    this.user = this.$store.state.auth.currentUser;
    if (this.user && this.user.is_admin) {
      this.listPedidosCancelamentos()
    }
    this.empresa = this.$store.state.auth.currenEmpresa;
  },
  computed: {
    entidade: {
      get: function () {
        return this.$store.state.auth.currentEntidade;
      },
    },
    valor_total_duams: {
      get: function () {
        return this.duams
            .map(d => Number(d.dut_valortributo))
            .reduce((sum, current) => sum + current, 0);
      }
    },
    valor_total_atualizado_duams: {
      get: function () {
        return this.duams
            .map(d => Number(d.dut_valortotal))
            .reduce((sum, current) => sum + current, 0);
      }
    }
  },
  methods: {
    listPedidosCancelamentos() {
      this.httpSend = true;
      listNotasPedidosCancelamento(0, this.filtros_pedidos_cancelamento).then(result => {
        if (result.status) {
          this.pedidos_cancelamentos = result.dados.total;
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    pagePedidos() {
      this.$router.push({name: 'admin-gestao-pedidos-cancelamento'});
    },
  },
};
</script>
<style scoped>

/* ─── Alerta cancelamentos ───────────────────────────────── */
.alert-cancelamento {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #fffbeb;
  border: 1px solid #fcd34d;
  border-left: 4px solid #f59e0b;
  border-radius: 10px;
  padding: 1rem 1.25rem;
}

.alert-icon {
  flex-shrink: 0;
  margin-top: 1px;
}

.alert-body {
  flex: 1;
  min-width: 0;
}

.alert-title {
  margin: 0 0 3px;
  font-size: 13px;
  font-weight: 600;
  color: #92400e;
}

.alert-desc {
  margin: 0;
  font-size: 13px;
  color: #b45309;
  line-height: 1.5;
}

.alert-desc strong {
  font-weight: 600;
  color: #92400e;
}

.alert-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.btn-cancelamento {
  display: flex;
  align-items: center;
  gap: 6px;
  background: #f59e0b;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  font-family: 'DM Sans', sans-serif;
  transition: background 0.15s, transform 0.1s;
}

.btn-cancelamento:hover {
  background: #d97706;
}

.btn-cancelamento:active {
  transform: scale(0.97);
}

.btn-fechar-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 5px;
  border-radius: 6px;
  transition: background 0.15s;
}

.btn-fechar-alert:hover {
  background: #fde68a;
}
</style>

